import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import { InputField } from "../../Shared/InputField"

const ChangePasswordForm = () => {
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: ""
  })

  const { old_password, new_password, confirm_password } = formData
  const navigate = useNavigate()

  const checks = {
    length: new_password.length >= 8,
    uppercase: /[A-Z]/.test(new_password),
    lowercase: /[a-z]/.test(new_password),
    number: /\d/.test(new_password),
    symbol: /[\W_]/.test(new_password),
  }

  const allValid = Object.values(checks).every(Boolean)

  const renderCheck = (label, passed) => (
    <li style={{ color: passed ? 'green' : 'red' }}>

      <span style={{ fontSize: '0.6rem', marginRight: 2 }}>
        {passed ? '✅' : '❌'}
      </span>
      {label}
    </li>
  )

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }))
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setErrors({})
    try {
      const response = await Server.post('/users/change-password', formData)
      toast.success("Password changed successfully!")
      navigate("/")
    } catch (error) {
      if (error.response?.status === 422) {
        error.response.data.detail.forEach((err) => {
          setErrors((prev) => ({ ...prev, [err.loc[1]]: err.msg }))
        })
      } else if (error.response?.status === 401) {
        navigate("/login")
      } else {
        toast.error(error.response?.data?.detail || "Unexpected error")
      }
    } finally {
      setIsLoading(false)
    }
  }

  if (isLoading) return <Spinner />

  return (
    <div className="card">
        <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
            <h3 className="card-title">Change Password Form</h3>
        </div>
      <div className="card-body">
        <form onSubmit={onSubmit}>
          <div className="row">
            <div className="col-md-6">
              <InputField
                label="Old Password"
                name="old_password"
                type="password"
                value={old_password}
                onChange={onChange}
                error={errors.old_password}
              />
            </div>
            <div className="col-md-6">
              <InputField
                label="New Password"
                name="new_password"
                type="password"
                value={new_password}
                onChange={onChange}
                error={errors.new_password}
              />
            </div>
            <div className="col-md-6">
              <InputField
                label="Confirm Password"
                name="confirm_password"
                type="password"
                value={confirm_password}
                onChange={onChange}
                error={errors.confirm_password}
              />
            </div>
            <div className="col-md-6">
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {renderCheck("At least 8 characters", checks.length)}
                {renderCheck("Uppercase letter", checks.uppercase)}
                {renderCheck("Lowercase letter", checks.lowercase)}
                {renderCheck("Number", checks.number)}
                {renderCheck("Symbol", checks.symbol)}
              </ul>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-12">
              <input
                type="submit"
                className="btn btn-outline-info float-end"
                value="Update Password"
                disabled={!allValid}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ChangePasswordForm